import styled from 'styled-components';

import { media, gridSizes } from 'utils/style';

import DiffPriceWhenEdit from 'components/Price/DiffPriceWhenEdit/component';

export default styled(DiffPriceWhenEdit)`
  ${media.lessThan('huge')`
        padding-left: ${gridSizes('M')};
  `}
  ${media.lessThan('large')`
    padding-left: 24px;
    p{margin-top: 0;}
  `}
`;
// 